import { cn } from "@/lib/utils";

export const OPTION_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function getOptionLetter(index: number) {
  return OPTION_LETTERS[index] ?? String(index + 1);
}

/**
 * `default` is the resting affordance on an unpicked option, `selected` the one the reader
 * chose, `muted` an option that cannot be picked right now.
 */
export type OptionLetterTone = "default" | "selected" | "muted";

const TONE_CLASS: Record<OptionLetterTone, string> = {
  default: "bg-surface-blue text-blue-content",
  selected: "bg-primary text-primary-foreground",
  muted: "bg-muted text-muted-foreground",
};

/** The A/B/C key badge in front of an option row, on the ask-user dock and in the transcript. */
export function OptionLetterBadge({ letter, tone }: { letter: string; tone: OptionLetterTone }) {
  return (
    <span
      className={cn(
        "flex size-[26px] shrink-0 items-center justify-center font-mono text-[12px] font-semibold",
        TONE_CLASS[tone]
      )}
    >
      {letter}
    </span>
  );
}
